
import { useRouter } from 'next/router';

export default function Layout({ children }) {
  const router = useRouter();

  
  return (
    <div className='min-h-screen flex flex-col'>
     <div className='flex flex-col md:flex-row flex-1'>
       <main className='flex-1'>{children}</main>
      </div>
      
    </div>
  );
}